<script>
import { mapGetters } from "vuex";
import { aplicarNoDocumento, dataComemorativaAtiva } from "@/plugins/datasComemorativas";

// Aplica no <html> a cor do topo da data comemorativa em andamento. Não desenha nada.
export default {
  name: "EDataComemorativaTema",
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("AppConfigurations", ["moduloAtivo"]),
    data() {
      return dataComemorativaAtiva(this.user, this.moduloAtivo);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        aplicarNoDocumento(data);
      },
    },
  },
  render() {
    return null;
  },
};
</script>
